export enum NetworkRequestOutcome {
  Unknown,
  Succeeded,

  /// http code is not 200
  Failed,

  /// http code is 200 but "code" in JSON response is not 0
  ProbablyFailed,

  Canceled,
}

const successHttpCodes = new Set<number>([200, 304]);

export function parseNetworkRequestOutcome(args: {
  canceled: boolean;
  httpStatusCode: number | undefined;
}): NetworkRequestOutcome {
  let status = NetworkRequestOutcome.Unknown;

  if (args.canceled) {
    status = NetworkRequestOutcome.Canceled;
  } else if (typeof args.httpStatusCode === 'number') {
    if (successHttpCodes.has(args.httpStatusCode)) {
      status = NetworkRequestOutcome.Succeeded;
    } else {
      status = NetworkRequestOutcome.Failed;
    }
  }

  return status;
}
